import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnimateGradient = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 16",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "animatePurpleGradient",
			x1: "0%",
			y1: "0%",
			x2: "100%",
			y2: "100%",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: "0%",
					style: {
						stopColor: "#2214e4",
						stopOpacity: 1
					}
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: "50%",
					style: {
						stopColor: "#d696ce",
						stopOpacity: 1
					}
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: "100%",
					style: {
						stopColor: "#2f67fe",
						stopOpacity: 1
					}
				})
			]
		}) }),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#animatePurpleGradient)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.45453 5.5C2.45453 5.15482 2.73435 4.875 3.07953 4.875H6.66927C7.01445 4.875 7.29427 5.15482 7.29427 5.5C7.29427 5.84518 7.01445 6.125 6.66927 6.125H3.07953C2.73435 6.125 2.45453 5.84518 2.45453 5.5ZM0.210938 9.2037C0.210938 8.85853 0.49076 8.5787 0.835938 8.5787H6.66927C7.01445 8.5787 7.29427 8.85853 7.29427 9.2037C7.29427 9.54888 7.01445 9.8287 6.66927 9.8287H0.835938C0.49076 9.8287 0.210938 9.54888 0.210938 9.2037ZM4.2494 12.1667C4.2494 11.8215 4.52922 11.5417 4.8744 11.5417H6.66927C7.01445 11.5417 7.29427 11.8215 7.29427 12.1667C7.29427 12.5118 7.01445 12.7917 6.66927 12.7917H4.8744C4.52922 12.7917 4.2494 12.5118 4.2494 12.1667Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#animatePurpleGradient)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.7943 3.47341C15.7412 2.53713 14.5243 2.21104 14.0102 2.99536L12.4901 5.31453C12.3377 5.54706 12.0532 5.65554 11.7847 5.58358L9.07594 4.85778C8.16279 4.6131 7.47283 5.68351 8.07276 6.41413L9.82799 8.55172C10.0067 8.7694 10.0233 9.07797 9.86889 9.31354L8.36332 11.6105C7.84762 12.3973 8.63836 13.3849 9.51887 13.0537L12.1478 12.0651C12.406 11.968 12.6973 12.0461 12.8723 12.2592L14.6547 14.4299C15.2517 15.1569 16.4303 14.697 16.3771 13.7578L16.2217 11.0158C16.2057 10.7345 16.3744 10.4756 16.638 10.3765L19.2269 9.40287C20.1117 9.0701 20.0494 7.79811 19.1363 7.55343L16.4275 6.82763C16.159 6.75567 15.9669 6.51951 15.9512 6.24193L15.7943 3.47341Z"
		})
	]
});
const ForwardRef = forwardRef(SvgAnimateGradient);
export default ForwardRef;
